module.exports = __webpack_public_path__ + "static/img/5.47a1d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/5.png
// module id = bj4H
// module chunks = 0